// 各个 tab 当前展示的页面的 vue 实例，在tab 切换时需要拿此实例来展示(基于css display)，
// 并且此tab下渲染别的页面时（path变更），此instance需要destroy和重建
// 依赖外部：this.initTabs()、 this.getTabName()、this.menuCode
import TabRouter from './TabRouter'
import { TAB_LIST_SESSION_KEY } from '../layout-tab/constans'

const genUid = function () {
  return '' + Math.floor(Math.random() * 10000) + (new Date).getTime()
}

// 无需响应式所以放在这里，性能优化角度
const components = {
  // uid: component
}
  
// 当tab切换时，要跳转到的tab，并且可以用区分是否是tab切换导致的路由变化
let tabSwitched = null

export default {
  data () {
    let storageTabs = this.initTabs()
    return {
      tabs: storageTabs || [
        // 每个元素对应一个tab
        // {
        //   uid: 'xx', // 此tab 的uid，时间戳+随机数
        //   menuCode: '', // 同一个 menuCode 值的所有页面共享同一个tab
        //   path: '/order/edit', // 当前展示的页面路由
        //   fullPath: '' // 当前展示的页面路由的fullPath
        //   instanceUid: '' // // 当前展示的页面的实例 uid
        // }
        
      ],
      currentTabUid: '' // 当前展示的tab 的uid
    }
  },
  watch: {
    '$route': {
      handler: function (currentRoute, preRoute) {
        // console.log('$route change', currentRoute, preRoute, this.$router)
        this.routeChanged(currentRoute, preRoute)
      },
      immediate: true
    }
  },
  methods: {
    // 路由改变了
    routeChanged (currentRoute, preRoute) {
      // 初始化 tabRouter
      if (!this.tabRouter) {
        this.tabRouter = new TabRouter(this.$router)
      }
      
      const tab = this.tabs.find(_ => _.path === currentRoute.path)
      // 回退的处理
      if (this.tabRouter.isBack) {
        if (tab) {
          tab.path = currentRoute.path
          tab.fullPath = currentRoute.fullPath
          
          this.currentTabUid = tab.uid
        } else {
          this.pageChanged()
        }
        
        this.tabRouter.resetIsBack()
        return
      }
      
      // 非回退非tab切换，则record
      if (!this.tabRouter.isBack && !tabSwitched) {
        this.tabRouter.record(currentRoute, preRoute)
      }
      
      // tab切换
      // 包含页面初始化场景：页签下实例存在正常切换，不存在重新创建实例
      if (tabSwitched) {
        if (components[tabSwitched.uid]) {
          this.tabChanged()  
        } else {
          this.pageChanged()
          tabSwitched = null
        }
        return
      }
      
      // 正常路由变化的处理，只在路径不同时才处理
      if (!preRoute || currentRoute.path !== preRoute.path) {
        this.pageChanged()
      }
    },
    // tab切换：只影响tab的展示，不涉及页面实例的处理
    tabChanged () {
      this.currentTabUid = tabSwitched.uid
      tabSwitched = null
    },
    // 页面切换：涉及页面实例的处理和tab的展示
    pageChanged () {
      const matched = this.$route.matched
      if (!matched.length) return
      const component = matched[matched.length - 1].components.default
      if (!component) return
      
      let tab = this.tabs.find((tab) => {
        return tab.menuCode === this.menuCode
      })
      
      // 如果没有则创建
      if (!tab) {
        tab = {
          uid: genUid(), // 此tab 的uid，时间戳+随机数
          menuCode: this.menuCode || this.$route.meta.menuCode, // 同一个 menuCode 值的所有页面共享同一个tab
          name: this.getTabName(),
          path: '',
          fullPath: '',
          instanceUid: ''
        }
        this.tabs.push(tab)
      }
  
      tab.path = this.$route.path
      tab.fullPath = this.$route.fullPath
      tab.instanceUid = genUid()
  
      // 更新存的component
      components[tab.uid] = component
      
      // 展示此tab
      this.currentTabUid = tab.uid

      // 存sessionStorage
      this.updateTabsStorage()
    },
    // tab 切换
    switchTab (tab) {
      tabSwitched = tab
      this.$router.push(tab.fullPath)
    },
    // 关掉 tab
    closeTab (tab) {
      const index = this.tabs.findIndex(item => item.menuCode === tab.menuCode)
      if (index === -1) return

      // 删除当前页签时跳到上一个页签
      if (tab.menuCode === this.menuCode) {
        const preTab = this.tabs[index - 1]
        this.switchTab(preTab)
      }
      
      this.tabs.splice(index, 1)
      this.updateTabsStorage()
    },
    // 存 sessionStorage
    updateTabsStorage () {
      sessionStorage.setItem(TAB_LIST_SESSION_KEY, JSON.stringify(this.tabs))
    },
    // 根据tab uid 获取component
    getComponent (tabUid) {
      return components[tabUid]
    },
    // 对外接口 - 用于侧边栏的场景，如果有此页面则只是简单地切换tab，如果没有此页面则切换页面
    openPage (path) {
      const tab = this.tabs.find(_ => _.path === path)
      if (tab) {
        this.switchTab(tab)
      } else {
        this.$router.push(path)
      }
    },
    // 对外接口 - 用于回退
    back () {
      this.tabRouter.back()
    },
    // 对外接口 - 重置并清空页签
    reset () {
      this.tabs = []
      this.currentTabUid = ''
      this.updateTabsStorage()
      this.tabRouter.reset()
    },
    // 对外接口 - 在从非页签页面进入页签页面时，设置其pre route
    setPreRoute (current, prev) {
      this.tabRouter.record(current, prev)
    }
  }
}